import { render } from "./formhero.vue?vue&type=template&id=a173035a&scoped=true"
import script from "./formhero.vue?vue&type=script&lang=js"
export * from "./formhero.vue?vue&type=script&lang=js"

import "./formhero.vue?vue&type=style&index=0&id=a173035a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a173035a"

export default script